import * as bootstrapModule from 'bootstrap/dist/js/bootstrap.bundle.min.js';

(function (window, document) {
	'use strict';

	const bootstrap = window.bootstrap || bootstrapModule;

	if (!bootstrap) {
		return;
	}

	const $ = window.jQuery;

	const getSelector = (trigger) => {
		const target =
			trigger.getAttribute('data-bs-target') ||
			trigger.getAttribute('data-target') ||
			trigger.getAttribute('href');

		if (!target || target === '#') {
			return '';
		}

		return target.includes('#') && !target.startsWith('#')
			? `#${target.split('#').pop()}`
			: target;
	};

	const getTargetElement = (trigger) => {
		const selector = getSelector(trigger);

		if (!selector || !selector.startsWith('#')) {
			return null;
		}

		try {
			return document.querySelector(selector);
		} catch (error) {
			return null;
		}
	};

	const syncLegacyTabState = (trigger) => {
		const list = trigger.closest('.nav, .nav-tabs, .nav-pills, .tab_service, .mobi_price_menu_ul');

		if (list) {
			list.querySelectorAll('li').forEach((item) => item.classList.remove('active'));
			trigger.closest('li')?.classList.add('active');
		}
	};

	const showLegacyTab = (trigger) => {
		const pane = getTargetElement(trigger);

		if (!pane) {
			return;
		}

		const scope = pane.closest('.tab-content') || document;
		const list = trigger.closest('.nav, .nav-tabs, .nav-pills, .tab_service, .mobi_price_menu_ul');

		if (list) {
			list.querySelectorAll('[data-toggle="tab"], [data-toggle="pill"], [data-bs-toggle="tab"], [data-bs-toggle="pill"]').forEach((tab) => {
				tab.classList.remove('active');
				tab.setAttribute('aria-selected', 'false');
			});
		}

		scope.querySelectorAll('.tab-pane').forEach((tabPane) => {
			tabPane.classList.remove('active', 'show', 'in');
		});

		trigger.classList.add('active');
		trigger.setAttribute('aria-selected', 'true');
		pane.classList.add('active', 'show', 'in');
		syncLegacyTabState(trigger);
	};

	const callComponent = (Component, element, action, relatedTarget) => {
		if (!Component || !element) {
			return;
		}

		const instance = Component.getOrCreateInstance(element);

		if (typeof instance[action] === 'function') {
			instance[action](relatedTarget);
		}
	};

	document.addEventListener('click', (event) => {
		const trigger = event.target.closest('[data-toggle], [data-dismiss]');

		if (!trigger) {
			return;
		}

		const toggle = trigger.getAttribute('data-toggle');
		const dismiss = trigger.getAttribute('data-dismiss');

		if (toggle === 'modal') {
			const modal = getTargetElement(trigger);

			if (modal) {
				event.preventDefault();
				callComponent(bootstrap.Modal, modal, 'show', trigger);
			}
		}

		if (dismiss === 'modal') {
			const modal = trigger.closest('.modal');

			if (modal) {
				event.preventDefault();
				callComponent(bootstrap.Modal, modal, 'hide', trigger);
			}
		}

		if (toggle === 'tab' || toggle === 'pill') {
			event.preventDefault();
			showLegacyTab(trigger);
		}

		if (toggle === 'dropdown') {
			event.preventDefault();
			callComponent(bootstrap.Dropdown, trigger, 'toggle', trigger);
		}

		if (toggle === 'collapse') {
			const collapse = getTargetElement(trigger);

			if (collapse) {
				event.preventDefault();
				callComponent(bootstrap.Collapse, collapse, 'toggle', trigger);
			}
		}
	});

	document.addEventListener('shown.bs.tab', (event) => {
		if (event.target instanceof HTMLElement) {
			syncLegacyTabState(event.target);
		}
	});

	if (!$) {
		return;
	}

	if (!$.fn.modal && bootstrap.Modal) {
		$.fn.modal = function (action = 'show') {
			return this.each(function () {
				callComponent(bootstrap.Modal, this, action);
			});
		};
	}

	if (!$.fn.tab) {
		$.fn.tab = function (action = 'show') {
			return this.each(function () {
				if (action === 'show') {
					showLegacyTab(this);
				}
			});
		};
	}

	if (!$.fn.dropdown && bootstrap.Dropdown) {
		$.fn.dropdown = function (action = 'toggle') {
			return this.each(function () {
				callComponent(bootstrap.Dropdown, this, action);
			});
		};
	}
})(window, document);
